export default function deriveIdFromProjectList(mainProjects, projectName) {
  const projectId = mainProjects.filter((project) => {
    if (project.title.includes(projectName)) {
      return project.id
    }
  })
  return projectId[0] ? projectId[0].id : 0
}
